/* eslint-disable max-lines */
/* eslint-disable react/jsx-max-depth */
import PropTypes from 'prop-types';
import queryString from 'querystring';
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';
import Button from '../../components/elements/Button';
import Card from '../../components/elements/Card';
import ErrorHandler from '../../components/elements/ErrorHandler';
import LoadingBars from '../../components/elements/LoadingBars';
import Select from '../../components/fields/Select';
import Text from '../../components/fields/Text';
import {
  fetchCities,
  fetchProvinces,
  fetchRegionals,
} from '../../components/layouts/PageBase/actions';
import { AppContext } from '../../contexts';
// import { getRegional } from '../../utils/storage';
import { fetchProductPrices } from './actions';
import { validate } from './constants';
import styles from './styles.scoped.css';

export function Component(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { change, handleSubmit, submitting } = props;

  const { setBreadcrumbs } = useContext(AppContext);

  const { dataProductCategories } = useSelector((s) => s.pageBase);

  const { type } = useParams();

  const {
    region: queryRegion,
    provinceId: queryProvince,
    cityId: queryCity,
    maxPrice: queryMax,
    minPrice: queryMin,
  } = queryString.parse(location.search.replace('?', ''));

  const { dataRegionals, dataProvinces, dataCities } = useSelector(
    (s) => s.pageBase
  );
  const { dataDetailUser } = useSelector((s) => s.pageBase);

  const [category, setCategory] = useState(null);
  const [region, setRegion] = useState(
    queryRegion ?? dataDetailUser?.regionalId
  );
  const [provinceId, setProvinceId] = useState(queryProvince ?? '');
  const [cityId, setCityId] = useState(queryCity ?? '');
  const {
    messageProductPrices = '',
    dataSubmitProductPrices,
    isLoadingSubmitProductPrices,
  } = useSelector((s) => s.prices);

  const hargaJualMin = {
    placeholder: 'Harga Jual Minimum Per Tabung',
    label: 'Harga Jual Minimum Per Tabung',
    icon: '',
  };

  const hargaJualMax = {
    placeholder: 'Harga Jual Maksimum Per Tabung',
    label: 'Harga Jual Maksimum Per Tabung',
    icon: '',
  };

  useEffect(() => {
    dispatch(fetchRegionals());
    dispatch(fetchProvinces({ regional: JSON.stringify([region]) }));
    dispatch(
      fetchCities({
        regional: JSON.stringify([region]),
        provinceId: JSON.stringify([provinceId]),
      })
    );
  }, []);

  useEffect(() => {
    const findCategory = dataProductCategories.find(
      (c) => c.name.toLowerCase().trim() === type
    );
    if (findCategory) {
      setCategory(findCategory);
      setBreadcrumbs(['Atur Harga Produk', findCategory.name]);
    }
  }, [type, dataProductCategories]);

  const onRegionChanged = (value = '') => {
    setRegion(value);
    change('region', value);
    dispatch(fetchProvinces({ regional: JSON.stringify([value]) }));
    dispatch(fetchCities({ regional: JSON.stringify([value]) }));
    // onProvinceChanged();
  };

  const onProvinceChanged = (value = '') => {
    setProvinceId(value);
    change('provinceId', value);
    onCityChanged();
    dispatch(fetchCities({ provinceId: JSON.stringify([value]) }));
  };

  const onCityChanged = (value = '') => {
    setCityId(value);
    change('cityId', value);
  };

  useEffect(() => {
    change('region', queryRegion || region || '');
    change('provinceId', queryProvince || provinceId || '');
    change('cityId', queryCity || cityId || '');
    change('hargaJualMin', queryMin);
    change('hargaJualMax', queryMax);
    setBreadcrumbs(['Atur HET LPG 3 Kg', 'Ubah Semua Harga']);
  }, []);

  useEffect(() => {
    if (category?.categoryId) {
      dispatch(fetchProductPrices(category?.categoryId, cityId));
    }
  }, [category, cityId]);

  useEffect(() => {
    if (!isLoadingSubmitProductPrices && dataSubmitProductPrices) {
      navigate(`/price`);
    }
  }, [dataSubmitProductPrices, isLoadingSubmitProductPrices]);

  const getAreaByQuery = (data, query) => {
    return data.filter((p) => p.value === query);
  };

  if (messageProductPrices) {
    return <ErrorHandler message={messageProductPrices} />;
  }

  return (
    <div className={styles.form}>
      <Card className={styles.card}>
        {/* <h3>Ubah Harga Produk {category?.name}</h3> */}
        <form onSubmit={handleSubmit}>
          <div className={styles['input-group']}>
            <label>Regional</label>
            <Select
              data={
                queryRegion
                  ? getAreaByQuery(dataRegionals, region)
                  : [
                    {
                      value: '',
                      name: 'Semua Regional',
                      label: 'Semua Regional',
                    },
                    ...dataRegionals.filter((r) => r.value !== ''),
                  ]
              }
              disabled={dataDetailUser?.regionalId !== '' || queryRegion}
              hideLabel
              icon="chevron"
              onChange={(e) => onRegionChanged(e)}
              value={region}
            />
          </div>
          <div className={styles['input-group']}>
            <label>Provinsi</label>
            <Select
              data={
                queryProvince
                  ? [...getAreaByQuery(dataProvinces, queryProvince)]
                  : [
                    {
                      value: '',
                      name: 'Semua Provinsi',
                      label: 'Semua Provinsi',
                    },
                    ...dataProvinces.filter((r) => r.value !== ''),
                  ]
              }
              disabled={queryProvince}
              hideLabel
              icon="chevron"
              onChange={(e) => onProvinceChanged(e)}
              value={provinceId}
            />
          </div>
          <div className={styles['input-group']}>
            <label>Kota/Kabupaten</label>
            <Select
              data={
                queryCity
                  ? [...getAreaByQuery(dataCities, queryCity)]
                  : [
                    {
                      value: '',
                      name: 'Semua Kota/Kabupaten',
                      label: 'Semua Kota/Kabupaten',
                    },
                    ...dataCities.filter((r) => r.value !== ''),
                  ]
              }
              disabled={queryCity}
              hideLabel
              icon="chevron"
              onChange={(e) => onCityChanged(e)}
              value={cityId}
            />
          </div>
          <Field
            component={Text}
            inputProps={hargaJualMin}
            name="hargaJualMin"
          />
          <Field
            component={Text}
            inputProps={hargaJualMax}
            name="hargaJualMax"
          />
          <div className={styles['form-action']}>
            <Button
              // disabled={submitting || pristine}
              onClick={() => navigate('/price')}
              outlined={true}
            >
              Batal
            </Button>
            <Button disabled={submitting} type="submit">
              Simpan
            </Button>
          </div>
        </form>
      </Card>
    </div>
  );
}

export const RenderProducts = ({ fields }) => {
  const { dataProductPrices, isLoadingProductPrices } = useSelector(
    (s) => s.prices
  );

  useEffect(() => {
    fields.splice(0, fields.length + 1);
    if (dataProductPrices.products.length) {
      dataProductPrices.products.forEach((product) => {
        fields.push(product);
      });
    }
  }, [dataProductPrices]);

  const number = (value) => value && parseFloat(value.replace(/[^\d]/g, ''));

  const renderProductName = (name) => {
    if (
      name === 'LPG 3 Kg' ||
      name === 'Bright Gas 5,5 Kg' ||
      name === 'Bright Gas 12 Kg'
    ) {
      return `${name} (per tabung)`;
    } else {
      return name;
    }
  };

  if (isLoadingProductPrices) {
    return (
      <div className={styles['loading-container']}>
        <LoadingBars size={10} />
      </div>
    );
  }
  return (
    <div>
      {fields.map((p, index) => (
        <div className={styles['price-input']} key={index}>
          <label>
            {renderProductName(dataProductPrices?.products[index]?.productName)}
          </label>
          <div>
            <div>
              <label>Harga Modal</label>
              <Field
                component={Text}
                hideLabel
                inputProps={{ placeholder: 'Harga Modal' }}
                name={`${p}.productModal`}
                normalize={number}
              />
            </div>
            <div>
              <label>Harga Jual Minimal</label>
              <Field
                component={Text}
                hideLabel
                inputProps={{ placeholder: 'Harga Jual Minimal' }}
                name={`${p}.productMinPrice`}
                normalize={number}
              />
            </div>
            <div>
              <label>Harga Jual Maksimal</label>
              <Field
                component={Text}
                hideLabel
                inputProps={{ placeholder: 'Harga Jual Maksimal' }}
                name={`${p}.productMaxPrice`}
                normalize={number}
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

Component.propTypes = {
  change: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
};

RenderProducts.propTypes = {
  fields: PropTypes.object.isRequired,
};

export default reduxForm({
  form: 'product-prices',
  productGeneralMinPrice: 0,
  productGeneralMaxPrice: 0,
  initialValues: {
    region: '',
    provinceId: '',
    cityId: '',
    // products: [],
    hargaJualMin: '',
    hargaJualMax: '',
  },
  validate(values, props) {
    return validate(values, props.productGeneralMaxPrice, props.productGeneralMinPrice);
  }
})(Component);
